import { apiClient } from '@core/api/ApiClientFactory';
import type { Product, ProductType } from '@core/store/slices/apiSlice';

export const productService = {
    // Product Types
    async loadRfidTagProductTypes(): Promise<ProductType[]> {
        try {
            const response = await apiClient.get<ProductType[]>('rfidTagProductType');
            return response.data;
        } catch (error) {
            console.error('[ProductService] Error loading product types:', error);
            throw error;
        }
    },

    async createRfidTagProductType(item: ProductType): Promise<void> {
        try {
            await apiClient.post('rfidTagProductType', (({ id, ...rest }) => rest)(item));
            return;
        } catch (error) {
            console.error('[ProductService] Error creating rfid tag product type:', error);
            throw error;
        }
    },

    async updateRfidTagProductType(id: string, item: ProductType): Promise<void> {
        try {
            await apiClient.put(`rfidTagProductType/${id}`, item);
            return;
        } catch (error) {
            console.error('[ProductService] Error updating rfid tag product type:', error);
            throw error;
        }
    },

    // Products
    async createRfidTagProduct(item: Product): Promise<void> {
        try {
            await apiClient.post('rfidTagProduct', (({ id, ...rest }) => rest)(item));
            return;
        } catch (error) {
            console.error('[ProductService] Error creating rfid tag product:', error);
            throw error;
        }
    },

    async updateRfidTagProduct(id: string, item: Product): Promise<void> {
        try {
            await apiClient.put(`rfidTagProduct/${id}`, item);
            return;
        } catch (error) {
            console.error('[ProductService] Error updating rfid tag product:', error);
            throw error;
        }
    }
};
